import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class TarefaList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tarefas: [],
        };
    }

    componentDidMount = async () => {
        this.atualizarTarefas();
    }

    atualizarTarefas = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/tarefasDia?data=205012312359`);
            this.setState({ tarefas: res.data });
            console.log(res.data);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    concluirTarefa = async id => {
        await axios.put(`${ambiente.dev.server}/tarefasConcluir/${id}`);
        this.atualizarTarefas();
    }

    render() {
        return (
            <div>
                <div className="list-group">
                    {this.state.tarefas.map(item =>
                        <li key={item.id} className="list-group-item list-group-item-action flex-column align-items-start">
                            <div className="d-flex w-100 justify-content-between">
                                <h5 className="mb-1">{item.descricao}</h5>
                                <small>{item.dt_previsao}</small>
                            </div>
                            <div className="d-flex w-100 justify-content-between">
                                <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                                    onClick={() => this.concluirTarefa(item.id)} />
                            </div>
                        </li>
                    )}
                </div>
            </div>
        );
    }
}

TarefaList.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired,
};

function mapStateToProps({ filtro }) {
    return {
        filtro: filtro
    };
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TarefaList);



// WEBPACK FOOTER //
// ./src/components/tarefas/TarefaList.js